export default "__VITE_ASSET__D63koR27__"